import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../../styles.css";
const BaseListItem = _ref => {
  let {
    active,
    children,
    classes,
    disabled,
    liRef,
    onClick,
    ...rest
  } = _ref;
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  let itemClass = classes.item;
  if (active) itemClass = classes['item-is-active'];
  if (disabled) itemClass = classes['item-is-disabled'];
  return /*#__PURE__*/React.createElement("li", _extends({}, rest, {
    className: itemClass,
    ref: liRef,
    role: "option",
    "aria-selected": "false",
    onClick: !disabled && onClick ? onClick : null
  }), children);
};
process.env.NODE_ENV !== "production" ? BaseListItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  liRef: PropTypes.func,
  onClick: PropTypes.func,
  classes: classesPropType(['container', 'is-open', 'list-container', 'list', 'item', 'item-is-disabled', 'item-is-active'])
} : void 0;
export default withClasses(styles)(BaseListItem);